<app-tiles-group
  (tileSelectedEvent)="onTileSelected($event)"
  [tileCodeDetails]="reviewerTileCodeDetails"
  [tilesCount]="reviewerDashboardTilesCountModel"
  [selectedTileCode]="selectedTileCode"
  [dashboardType]="dashboard"
></app-tiles-group>
<div class="start-page-tabs" *ngIf="reviewerDashboardTilesCountModel">
  <startpage-grid-area
    [currentDashboardTileCode]="currentDashboardTileCode"
    [currentTileNameForGrid]="selectedTileCode"
    [gridColumns]="gridColumns"
    [model]="model"
    [gridTitle]="gridTitle"
    [dashboardfilters]="reviewerDashboardfilters"
    [buttonOptionsList]="buttonOptionsList"
    [filterDataList]="filterDataList"
    [tabsList]="tabsList"
    [selectedTabCode]="selectedTabCode"
    [selfReviewTileGuidanceValue]="selfReviewTileGuidanceValue"
    (buttonSelectedEvent)="buttonSelected($event)"
    (gridUpdatedEvent)="gridUpdatedEvent($event)"
    (tabChangeEvent)="tabChangeEvent($event)"
  >
  </startpage-grid-area>
  <app-new-pagination-and-grid
    *ngIf="model && model.length > 0"
    [tileCountforPage]="this.countforPagination"
    [itemsPerPage]="itemsPerPage"
    [list]="itemsPerPageOptions"
    [pageUI]="this.gotoPage + 1"
    (pageChanged)="onPageChanged($event)"
    (valueChanged)="onValueChanged($event)"
  ></app-new-pagination-and-grid>
  <div class="my-2 modal-margin" *ngIf="showRecentlyViewed">
    <dds-button
      [theme]="options.theme ?? ''"
      [kind]="options.kind ?? ''"
      [size]="options.size ?? ''"
      [width]="options.width ?? ''"
      [icon]="options.icon ?? ''"
      [isIconLeft]="options.isIconLeft ?? false"
      [role]="options.role ?? ''"
      [isInverse]="options.isInverse ?? false"
      [isColorBg]="options.isColorBg ?? false"
      [isLoading]="options.isLoading ?? false"
      [ariaLabel]="options.ariaLabel ?? ''"
      [customClass]="options.customClass ?? ''"
      [disabled]="options.disabled ?? false"
      (clicked)="openModalForRecentlyViewed()"
      >Recently viewed</dds-button
    >
  </div>
</div>
